import React, { useEffect } from "react"
import { trackLeadConversion } from "./leadConversion"

const CAL_NAMESPACE = "collar-website"
const CAL_PROFILE_LINK = "collar"
const CAL_EMBED_ORIGIN = "https://app.cal.com"

function trackCalBooking(bookingEvent) {
  if (typeof window === "undefined") return

  // Prefer a stable Cal booking ID when available; retain a short fallback
  // window for duplicate events that do not include one.
  const bookingData = bookingEvent?.detail?.data
  const bookingId = bookingData?.uid || bookingData?.bookingUid || bookingData?.id

  if (bookingId) {
    window.__collarTrackedCalBookingIds = window.__collarTrackedCalBookingIds || new Set()
    if (window.__collarTrackedCalBookingIds.has(String(bookingId))) return
  }

  const tracked = trackLeadConversion({
    dataLayerEvent: "cal_booking_success",
    method: "cal.com",
  })

  if (tracked && bookingId) {
    window.__collarTrackedCalBookingIds.add(String(bookingId))
  }
}

function ensureCalEmbed() {
  if (typeof window === "undefined" || typeof document === "undefined") return
  if (window.__collarCalEmbedInitialized) return

  window.__collarCalEmbedInitialized = true

  // Cal's embed bootstrap queues setup calls until its async loader is ready.
  ;(function (C, A, L) {
    const queue = function (api, args) {
      api.q.push(args)
    }
    C.Cal = C.Cal || function () {
      const cal = C.Cal
      const args = arguments
      if (!cal.loaded) {
        cal.ns = {}
        cal.q = cal.q || []
        const script = C.document.createElement("script")
        script.src = A
        script.async = true
        C.document.head.appendChild(script)
        cal.loaded = true
      }

      if (args[0] === L) {
        const api = function () {
          queue(api, arguments)
        }
        const namespace = args[1]
        api.q = api.q || []
        if (typeof namespace === "string") {
          cal.ns[namespace] = cal.ns[namespace] || api
          queue(cal.ns[namespace], args)
          queue(cal, ["initNamespace", namespace])
        } else {
          queue(cal, args)
        }
        return
      }

      queue(cal, args)
    }
  })(window, `${CAL_EMBED_ORIGIN}/embed/embed.js`, "init")

  window.Cal("init", CAL_NAMESPACE, { origin: CAL_EMBED_ORIGIN })
  window.Cal.config = window.Cal.config || {}
  window.Cal.config.forwardQueryParams = true
  window.Cal.ns[CAL_NAMESPACE]("ui", {
    hideEventTypeDetails: false,
    layout: "month_view",
  })
  window.Cal.ns[CAL_NAMESPACE]("on", {
    action: "bookingSuccessfulV2",
    callback: trackCalBooking,
  })
}

export function openCalBookingModal() {
  if (typeof window === "undefined") return

  ensureCalEmbed()
  window.Cal.ns[CAL_NAMESPACE]("modal", {
    calLink: CAL_PROFILE_LINK,
    config: {
      layout: "month_view",
      useSlotsViewOnSmallScreen: "true",
    },
    uid: Date.now(),
  })
}

function getCalLink(fallbackUrl) {
  try {
    const url = new URL(fallbackUrl)
    return url.pathname.replace(/^\/+|\/+$/g, "") || CAL_PROFILE_LINK
  } catch {
    return CAL_PROFILE_LINK
  }
}

export default function CalBookingLink({
  triggerClass = "enquiry-button",
  buttonText = "Book a demo",
  wrapperClassName = "w-embed",
  fallbackUrl = "https://cal.com/collar",
}) {
  useEffect(() => {
    ensureCalEmbed()
  }, [])

  const trigger = (
    <button
      type="button"
      className={`${triggerClass} cal-booking-trigger`}
      data-cal-link={getCalLink(fallbackUrl)}
      data-cal-namespace={CAL_NAMESPACE}
      data-cal-config='{"layout":"month_view","useSlotsViewOnSmallScreen":"true"}'
    >
      {buttonText}
    </button>
  )

  return wrapperClassName ? <div className={wrapperClassName}>{trigger}</div> : trigger
}
